import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Button, Radio } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import auth from "../../../common/utility/auth";

const { Option } = Select;
const InputGroup = Input.Group;
class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.proveedor}
                            onChange={(e) => this.props.onChange("proveedor", e.target.value)}
                            placeholder="Filtrar por proveedor, Ruc"
                            autoComplete="off"
                            //onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipoComprobante ?
                                    { key: this.props.filter.idTipoComprobante } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por tipo de comprobante" />}
                            onChange={(option) => this.props.onChange("idTipoComprobante", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.tiposComprobante.map(item => ( //STATE DATA
                                item.codigoSunat == "01" || item.codigoSunat == "03" || item.codigoSunat == "05" || item.codigoSunat == "09" || item.codigoSunat == "14" ?
                                    <Option value={item.id} key={item.id}>{`${item.nombre}`}</Option> : null
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>


                    <Col className="gutter-row" sm={24} md={24} lg={4}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Resumen</Radio>
                                <Radio value={2}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;